import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AboutHeroConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-about-hero',
  standalone: false,
  templateUrl: './about-hero.component.html',
  styleUrls: ['./about-hero.component.scss']
})
export class AboutHeroComponent {
  @Input() hero: AboutHeroConfig | null = null;
}
